import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import axios from 'axios';

const PrivacyPage = (body: any) => {
  const { t } = useTranslation();
  const [bodyContent, setBodyContent] = useState<any>(null)

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // fetchContent()
  }, [])

  const fetchContent = async () => {
    const htmlFile = '/privacy-policy.html';

    try {
      const responseData = await axios.get(htmlFile);
      setBodyContent(responseData);
    }
    catch(err: any) {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }

  let privacyHTML = '<div style="text-align:left; margin:0 auto; padding: 24px;">\n' +
    '\n' +
    '        <p style="text-align: center; font-weight: bold; text-decoration: underline;">Privacy Policy<p>\n' +
    '\n' +
    '        <p style="text-align: center; font-weight: bold;">DREZY MARKETPLACE DATA PROTECTION NOTICE<p>\n' +
    '\n' +
    '        <p>This DrEzy Marketplace Data Protection Notice (“Notice”) describes how DrEzy Sdn. Bhd. (Company Registration No.:202001012405 (1368725-T)) either itself or\n' +
    '            through a third party engaged by DrEzy Marketplace which may include any service provider, uses your Personal Data.\n' +
    '            DrEzy Marketplace shall have the right to modify, update or amend the terms of this Notice at any time by placing the\n' +
    '            updated Notice on the DrEzy Marketplace website (“Website”) or mobile application (“App”) at the following link:\n' +
    '            marketplace.drezy.io. By continuing to communicate with DrEzy Marketplace or use DrEzy Marketplace services following the\n' +
    '            modifications, updates or amendments to this Notice, such actions shall signify your acceptance of such\n' +
    '            modifications, updates or amendments.\n' +
    '        <p>\n' +
    '\n' +
    '        <p style="font-weight: bold;">1. Collection of Personal Data</p>\n' +
    '\n' +
    '        <p>“Personal Data” means information about you, from which you are identifiable, including but not limited to your\n' +
    '            name, identification card number, passport or other identification number (where applicable), phone numbers\n' +
    '            (mobile, residential, workplace), residential address, workplace address, e-mail address, age or date of birth,\n' +
    '            race, marital status, name of spouse or child or family members, photograph, video image or voice/video\n' +
    '            recording, signature, occupation, salutation, bank account number(s), credit card details, the festivals you\n' +
    '            celebrate, your household income, household size, personal product preferences, preferred language, bio health\n' +
    '            data, medical history, past medications, allergy information, family history, social history, genetic\n' +
    '            characteristic, health and mental condition, diagnosis and other health information, information you would like\n' +
    '            to receive, any information about you which you have provided to DrEzy Marketplace in any correspondence or through the\n' +
    '            use of DrEzy Marketplace or third party websites and social media pages, from cookies, pixel tags, web beacons, IP\n' +
    '            addresses, type of browser, type of operating system, the name of your internet service provider, domains used\n' +
    '            by your service providers, mobile network, device identifiers, device settings, browser settings, type of mobile\n' +
    '            device, location information, content and advertisement accessed by you and navigational data, data provided to\n' +
    '            DrEzy Marketplace through its customer service channels, surveys and/or any information about you that has been or may be\n' +
    '            directly or indirectly collected, stored, used and processed by DrEzy Marketplace from time to time. If you do not wish\n' +
    '            to have cookies placed on your computer or mobile device while browsing the Website or App, please set your\n' +
    '            browsers to refuse cookies before using the Website or App, with the drawback that certain features of the\n' +
    '            Website or App may not function properly without the aid of cookies.</p>\n' +
    '\n' +
    '        <p>The provision of certain Personal Data is mandatory in certain circumstances and if you do not provide such\n' +
    '            Personal Data, DrEzy Marketplace will not be able to provide you the products or services you have requested. In most\n' +
    '            circumstances, the provision of your Personal Data is voluntary but if you do not provide DrEzy Marketplace with your\n' +
    '            Personal Data, DrEzy Marketplace may not be able to provide the products or services you have requested or attend to your\n' +
    '            request in an efficient manner and you may not be able to enjoy the benefit of offers and promotions by\n' +
    '            DrEzy Marketplace. You also acknowledge that the Personal Data furnished to us relating to your health information are\n' +
    '            not health information protected by privacy and if such health information is protected by privacy, you\n' +
    '            acknowledge that such health information was disclosed to us voluntarily by you and you consent to us using such\n' +
    '            health information for the purposes hereinbelow.</p>\n' +
    '\n' +
    '        <p style="font-weight: bold;">2. Sources of Personal Data</p>\n' +
    '\n' +
    '        <p>In addition to the Personal Data you provide to DrEzy Marketplace directly, DrEzy Marketplace may also collect your Personal Data\n' +
    '            from a variety of sources, and in various ways such as:-\n' +
    '        </p>\n' +
    '\n' +
    '        <ol class="c">\n' +
    '            <li>Through your access and use of the Website, App, social media pages and other online and telephone services,\n' +
    '                including the customer call centre;</li>\n' +
    '            <li>During interactions and communications between individuals or their representatives and DrEzy Marketplace\n' +
    '                representatives and/or third parties;</li>\n' +
    '            <li>When you complete an application form, enquiry form, purchase order, questionnaire, competition or survey or\n' +
    '                any other forms;</li>\n' +
    '            <li>When you provide feedback regarding DrEzy Marketplace services, Website or App;</li>\n' +
    '            <li>When you participate in DrEzy Marketplace offers and promotions;</li>\n' +
    '            <li>Credit reports and credit reporting agencies to indicate your credit worthiness;</li>\n' +
    '            <li>Governmental agencies, regulatory and statutory authorities;</li>\n' +
    '            <li>Publicly available sources and from third parties.</li>\n' +
    '        </ol>\n' +
    '\n' +
    '        <p style="font-weight: bold;">3. Purposes of Processing</p>\n' +
    '\n' +
    '        <p><br>DrEzy Marketplace may use and process your Personal Data to provide you the products and/or services you have\n' +
    '            requested,\n' +
    '            to perform the contract you have entered into with the Vendor, to perform the contract you have entered into\n' +
    '            with any service providers via our Website and/or App and for the purposes relating to the business and\n' +
    '            activities of DrEzy Marketplace which shall include, without limitation the following (“the Purposes”):\n' +
    '            </br></p>\n' +
    '\n' +
    '        <ol class="c">\n' +
    '            <li>to process, confirm and fulfill your requests regarding DrEzy Marketplace services or transactions;</li>\n' +
    '            <li>to facilitate the provision of medical services including sharing of personal data with other independent\n' +
    '                medical consultants;</li>\n' +
    '            <li>to contact you regarding your purchases, enquiries and requests;</li>\n' +
    '            <li>for user identification for login to Website, App, portals and other</li>\n' +
    '            <li>online services provided by or on behalf of DrEzy Marketplace;</li>\n' +
    '            <li>to ensure that the content is presented in the most effective manner for the device used;</li>\n' +
    '            <li>to comply with or to enforce the terms and conditions of any contract or agreement entered into by or on\n' +
    '                behalf of DrEzy Marketplace to which DrEzy Marketplace is otherwise bound or is obliged to observe;</li>\n' +
    '            <li>to process payment transactions;</li>\n' +
    '            <li>to conduct research, survey and analysis</li>\n' +
    '            <li>for internal administrative and technical support purposes;</li>\n' +
    '            <li>for internal and external investigations;</li>\n' +
    '            <li>for purposes of detection, prevention and prosecution of crime;</li>\n' +
    '            <li>to conduct audit and investigations, and manage risks and crises;</li>\n' +
    '            <li>to enforce or defend DrEzy Marketplace or its affiliates’ legal rights, interests or property and/or to obtain legal\n' +
    '                advice;</li>\n' +
    '            <li>for DrEzy Marketplace to comply with its obligations under law whether within or outside Malaysia; and you agree and\n' +
    '                consent to DrEzy Marketplace using and processing your Personal Data in the manner as identified in this Notice.</li>\n' +
    '        </ol>\n' +
    '\n' +
    '        <p style="font-weight: bold;">4. Marketing and promotional purpose</p>\n' +
    '\n' +
    '        <p>Unless you have indicated otherwise, DrEzy Marketplace may also use and process your Personal Data for marketing and\n' +
    '            advertising purposes such as to send you communication regarding DrEzy Marketplace latest offers, promotions, events,\n' +
    '            products or services such as newsletters or flyers by way of email, post, phone calls, social media platforms\n' +
    '            and any other mode of communications (“Marketing Purposes”).</p>\n' +
    '\n' +
    '        <p>If you do not consent to DrEzy Marketplace processing your Personal Data for the Marketing Purposes, please contact our\n' +
    '            Customer Service representative contact details of which are as provided in Clause 7 below.</p>\n' +
    '\n' +
    '        <p style="font-weight: bold;">5. Disclosure and Transfer of Personal Data</p>\n' +
    '\n' +
    '        <p>Your Personal Data may be transferred to, stored, used and processed in a jurisdiction other than Malaysia, such\n' +
    '            as in the following circumstances:</p>\n' +
    '\n' +
    '        <ol class="c">\n' +
    '            <li>where DrEzy Marketplace administrative functions are being performed outside of Malaysia;</li>\n' +
    '            <li>where DrEzy Marketplace or its service providers’ servers or back-up servers are located outside of Malaysia;</li>\n' +
    '            <li>where personal information is required to be disclosed to various law enforcement agencies outside of\n' +
    '                Malaysia;</li>\n' +
    '            <li>where DrEzy Marketplace service providers, contractors, agents or partners are located outside of Malaysia; and you\n' +
    '                understand and consent to the transfer of your Personal Data out of Malaysia as described herein.</li>\n' +
    '        </ol>\n' +
    '\n' +
    '        <p>Your Personal Data may be transferred, accessed or disclosed to third parties for the Purposes or for Marketing\n' +
    '            Purposes. Further, DrEzy Marketplace may engage other companies, service providers or individuals to perform functions on\n' +
    '            DrEzy Marketplace’ behalf, and consequently may provide access to or disclose your Personal Data to such service\n' +
    '            providers or third parties. The third parties referred to in this section include (without limitation):</p>\n' +
    '\n' +
    '        <ol class="c">\n' +
    '            <li>DrEzy Marketplace professional advisors, including legal advisors, auditors accountants and consultants;</li>\n' +
    '            <li>service providers such as DrEzy Marketplace’ information technology (IT) service provider;</li>\n' +
    '            <li>DrEzy Marketplace’ social media agency; and</li>\n' +
    '            <li>regulatory and governmental authorities within and outside Malaysia, in order to comply with statutory and\n' +
    '                government requirements. Your Personal Data may also be shared in connection with a corporate transaction\n' +
    '                involving DrEzy Marketplace, such as a sale of a subsidiary or a division, merger, consolidation, or asset sale, or\n' +
    '                in the unlikely event of winding up.</li>\n' +
    '        </ol>\n' +
    '\n' +
    '        <p style="font-weight: bold;">6. Personal Information from Minors and Other Individuals</p>\n' +
    '\n' +
    '        <p>As a parent or legal guardian, please do not allow the minor (individuals under 18 years of age) under your care\n' +
    '            to submit Personal Data to DrEzy Marketplace. In the event that such Personal Data is provided to DrEzy Marketplace, you hereby\n' +
    '            consent to the processing of the minor’s Personal Data as his/her parent or legal guardian and personally accept\n' +
    '            and agree to be bound by this Notice and take responsibility for his or her actions.</p>\n' +
    '\n' +
    '        <p style="font-weight: bold;">7. Access & Correction Requests, Inquiries or Complaints</p>\n' +
    '\n' +
    '        <p>Subject to any exceptions under applicable laws, you may request for access to and/or request correction of your\n' +
    '            Personal Data, request to limit the processing of your Personal Data for the Purposes or for Marketing Purposes\n' +
    '            and/or make any inquiries or complaints regarding your Personal Data by contacting:-\n' +
    '        </p>\n' +
    '\n' +
    '        <p>\n' +
    '            <b>Customer Service</b><br />\n' +
    '            E-mail: <a>reachus.marketplace@drezy.io</a><br />\n' +
    '            Telephone number: +6012 4502300\n' +
    '        </p>\n' +
    '\n' +
    '        <p>Please note that if you withdraw your consent for DrEzy Marketplace to process your Personal Data for the Purposes or for\n' +
    '            Marketing Purposes, DrEzy Marketplace may consequently not be able to transact with you and may be unable to provide you\n' +
    '            the products or services which you have requested.</p>\n' +
    '\n' +
    '        <p>In respect of your right to access and/or correct your Personal Data, DrEzy Marketplace has the right to refuse your\n' +
    '            requests for reasons permitted under law, such as where DrEzy Marketplace is not supplied with such information as is\n' +
    '            reasonably required to locate the Personal Data to which the data access request relates or ascertain in what\n' +
    '            way the Personal Data to which the data correction request relates is incorrect.</p>\n' +
    '\n' +
    '        <p style="font-weight: bold;">8. Acknowledgement and Consent</p>\n' +
    '\n' +
    '        <p>By communicating or engaging with DrEzy Marketplace, or using DrEzy Marketplace services, you acknowledge that you have read and\n' +
    '            understood this Notice and agree and consent to the use, processing and transfer of your Personal Data by\n' +
    '            DrEzy Marketplace as described in this Notice.</p>\n' +
    '\n' +
    '    </div>'

  return(
    <div className="iframe-container">
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>

      <div
        className="iframe"
        style={{ width: '80%', height: '500', overflow: 'auto' }}
        dangerouslySetInnerHTML={{ __html: privacyHTML }}
      />
    </div>
  )
}

export default PrivacyPage;
